'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowLeft, FeatherArrowRight, FeatherCheck, FeatherHourglass, FeatherLock, FeatherX } from '@subframe/core';
import Image from 'next/image';
import React from 'react';
import { Button } from './Button';
import { Dialog } from './Dialog';
export type TrialMomento = 'faltam7' | 'faltam3' | 'ultimoDia' | 'terminou';
export interface AvisoTrialModalProps {
  produtoNome: string;
  momento: TrialMomento;
  dataFim: string;
  diasRestantes?: number;
  usadoNoTeste?: number;
  unidadeLabel?: string;
  possessivoLabel?: string;
  itensPreservados?: string;
  acaoBloqueada?: string;
  onVerPlanos: () => void;
  onClose: () => void;
}
interface Slide {
  titulo: string;
  descricao: string;
}
const buildSlides = (momento: TrialMomento, dias: number, dataFim: string, acao: string): Slide[] => {
  if (momento === 'terminou') {
    return [{
      titulo: `Seu teste terminou em ${dataFim}`,
      descricao: `Você não consegue mais ${acao}, mas tudo o que você já fez continua aqui, disponível para consulta e download.`
    }, {
      titulo: 'Ative um plano para voltar a usar',
      descricao: 'Escolha a faixa que combina com o seu volume. Assim que o plano estiver ativo, você volta a criar de onde parou.'
    }];
  }
  const quando = momento === 'ultimoDia' ? 'hoje' : dias === 1 ? 'em 1 dia' : `em ${dias} dias`;
  return [{
    titulo: `Seu teste termina ${quando}`,
    descricao: `A partir de ${dataFim} você não conseguirá ${acao}. O que você já criou continua acessível para consulta e download.`
  }, {
    titulo: 'Ative um plano e siga sem interrupção',
    descricao: 'Escolha a faixa que combina com o seu volume e continue trabalhando sem pausa quando o teste terminar.'
  }];
};
const PainelAnimado = t0 => {
  const $ = _c(41);
  const {
    produtoNome,
    momento,
    dataFim,
    diasRestantes,
    usadoNoTeste,
    unidadeLabel,
    possessivoLabel
  } = t0;
  const terminou = momento === "terminou";
  let t1;
  if ($[0] !== produtoNome) {
    t1 = <span className="text-brand-600 text-[13px] font-semibold">{produtoNome}</span>;
    $[0] = produtoNome;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `rounded-full px-2.5 py-[3px] text-[10px] font-semibold text-white ${terminou ? "bg-error-600" : "bg-brand-400"}`;
  const t3 = terminou ? "Teste encerrado" : "Em teste";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <div className="mb-4 flex items-center justify-between gap-2">{t1}{t4}</div>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `flex h-8 w-8 flex-none items-center justify-center rounded-[10px] ${terminou ? "bg-error-50" : "bg-brand-50"}`;
  let t7;
  if ($[8] !== terminou) {
    t7 = terminou ? <FeatherLock className="text-error-600 h-4 w-4" /> : <FeatherHourglass className="text-brand-600 h-4 w-4" />;
    $[8] = terminou;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = terminou ? "0" : diasRestantes;
  let t10;
  if ($[13] !== t9) {
    t10 = <span className="text-default-font text-[22px] leading-none font-semibold">{t9}</span>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = terminou ? "dias restantes" : diasRestantes === 1 ? "dia restante" : "dias restantes";
  let t12;
  if ($[15] !== t11) {
    t12 = <span className="text-[11px] text-neutral-500">{t11}</span>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t12) {
    t13 = <div className="flex flex-col">{t10}{t12}</div>;
    $[17] = t10;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t8) {
    t14 = <div className="mb-1 flex items-center gap-2">{t8}{t13}</div>;
    $[20] = t13;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="text-[11px] font-medium text-neutral-700">Período de teste</span>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== dataFim) {
    t16 = <div className="flex items-center justify-between">{t15}<span className="text-brand-600 text-[11px] font-semibold">{dataFim}</span></div>;
    $[24] = dataFim;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  const t17 = `pm-r-bar1 h-full w-full rounded-full ${terminou ? "bg-error-600" : "bg-brand-600"}`;
  let t18;
  if ($[26] !== t17) {
    t18 = <div className="bg-brand-100 h-[7px] w-full overflow-hidden rounded-full"><div className={t17} /></div>;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t16 || $[29] !== t18) {
    t19 = <div className="mt-4 flex flex-col gap-1.5">{t16}{t18}</div>;
    $[28] = t16;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== possessivoLabel || $[32] !== unidadeLabel || $[33] !== usadoNoTeste) {
    t20 = typeof usadoNoTeste === "number" && usadoNoTeste > 0 && <div className="mt-4 flex items-center gap-2 border-t border-solid border-neutral-100 pt-3"><FeatherCheck className="text-success-700 h-3.5 w-3.5 flex-none" /><span className="text-[11px] text-neutral-600">{usadoNoTeste} {unidadeLabel} continuam {possessivoLabel}</span></div>;
    $[31] = possessivoLabel;
    $[32] = unidadeLabel;
    $[33] = usadoNoTeste;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="bg-brand-600 pm-r-toast absolute -bottom-3.5 left-1/2 flex items-center gap-1.5 rounded-full px-3.5 py-1.5 whitespace-nowrap shadow-lg"><FeatherCheck className="h-3 w-3 text-white" /><span className="text-[11px] font-semibold text-white">Plano ativo, sem interrupção</span></div>;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t14 || $[37] !== t19 || $[38] !== t20 || $[39] !== t5) {
    t22 = <div className="pm-float relative z-10 flex w-[80%] flex-col rounded-[14px] bg-white px-6 pt-[22px] pb-7 shadow-2xl">{t5}{t14}{t19}{t20}{t21}</div>;
    $[36] = t14;
    $[37] = t19;
    $[38] = t20;
    $[39] = t5;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  return t22;
};
export const AvisoTrialModal: React.FC<AvisoTrialModalProps> = t0 => {
  const $ = _c(84);
  const {
    produtoNome,
    momento,
    dataFim,
    diasRestantes: t1,
    usadoNoTeste,
    unidadeLabel: t2,
    possessivoLabel: t3,
    itensPreservados,
    acaoBloqueada: t4,
    onVerPlanos,
    onClose
  } = t0;
  const diasRestantes = t1 === undefined ? 0 : t1;
  const unidadeLabel = t2 === undefined ? "registros" : t2;
  const possessivoLabel = t3 === undefined ? "seus" : t3;
  const acaoBloqueada = t4 === undefined ? "criar registros novos" : t4;
  const [slide, setSlide] = React.useState(0);
  let T0;
  let T1;
  let handleAvancar;
  let isFirst;
  let isLast;
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let terminou;
  if ($[0] !== acaoBloqueada || $[1] !== dataFim || $[2] !== diasRestantes || $[3] !== itensPreservados || $[4] !== momento || $[5] !== onClose || $[6] !== onVerPlanos || $[7] !== slide) {
    const slides = buildSlides(momento, diasRestantes, dataFim, acaoBloqueada);
    const atual = slides[slide];
    isFirst = slide === 0;
    isLast = slide === slides.length - 1;
    terminou = momento === "terminou";
    let t14;
    if ($[23] !== isLast || $[24] !== onVerPlanos) {
      t14 = () => {
        if (isLast) {
          onVerPlanos();
          return;
        }
        setSlide(_temp);
      };
      $[23] = isLast;
      $[24] = onVerPlanos;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    handleAvancar = t14;
    T1 = Dialog;
    t12 = true;
    if ($[26] !== onClose) {
      t13 = open => !open && onClose();
      $[26] = onClose;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    T0 = Dialog.Content;
    t11 = "w-full max-w-[980px] overflow-hidden rounded-[16px] border-0 p-0";
    t10 = "flex w-full flex-col md:min-h-[520px] md:flex-row";
    t8 = "flex flex-col justify-between gap-8 p-8 md:flex-[2]";
    let t15;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <Image src="/icone.svg" alt="Arbitralis" width={32} height={32} className="h-8 w-8" />;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    const t16 = <div className="flex flex-col gap-3"><h2 className="text-[26px] leading-tight font-semibold text-neutral-800">{atual.titulo}</h2><p className="text-base leading-relaxed text-neutral-500">{atual.descricao}</p></div>;
    let t17;
    if ($[29] !== acaoBloqueada || $[30] !== isFirst || $[31] !== itensPreservados || $[32] !== terminou) {
      t17 = isFirst && <div className="flex flex-col gap-2.5"><div className="flex items-start gap-2"><FeatherCheck className="text-success-700 mt-0.5 h-4 w-4 shrink-0" /><span className="text-caption font-caption text-default-font">{itensPreservados ?? "Seus registros continuam dispon\xEDveis para consulta e download"}</span></div><div className="flex items-start gap-2"><FeatherX className="text-error-700 mt-0.5 h-4 w-4 shrink-0" /><span className="text-caption font-caption text-default-font">Você não {terminou ? "consegue" : "poder\xE1"} {acaoBloqueada}</span></div></div>;
      $[29] = acaoBloqueada;
      $[30] = isFirst;
      $[31] = itensPreservados;
      $[32] = terminou;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    if ($[34] !== t16 || $[35] !== t17) {
      t9 = <div className="flex flex-col gap-8">{t15}{t16}{t17}</div>;
      $[34] = t16;
      $[35] = t17;
      $[36] = t9;
    } else {
      t9 = $[36];
    }
    t7 = "flex flex-col gap-6";
    t5 = "flex items-center gap-2";
    let t18;
    if ($[37] !== slide) {
      t18 = (_, index) => <button key={index} type="button" aria-label={`Ir para o slide ${index + 1}`} onClick={() => setSlide(index)} className={`h-2 rounded-full transition-all ${index === slide ? "bg-brand-600 w-6" : "w-2 bg-neutral-300"}`} />;
      $[37] = slide;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    t6 = slides.map(t18);
    $[0] = acaoBloqueada;
    $[1] = dataFim;
    $[2] = diasRestantes;
    $[3] = itensPreservados;
    $[4] = momento;
    $[5] = onClose;
    $[6] = onVerPlanos;
    $[7] = slide;
    $[8] = T0;
    $[9] = T1;
    $[10] = handleAvancar;
    $[11] = isFirst;
    $[12] = isLast;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = terminou;
  } else {
    T0 = $[8];
    T1 = $[9];
    handleAvancar = $[10];
    isFirst = $[11];
    isLast = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
    terminou = $[22];
  }
  let t14;
  if ($[39] !== t5 || $[40] !== t6) {
    t14 = <div className={t5}>{t6}</div>;
    $[39] = t5;
    $[40] = t6;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== isFirst || $[43] !== onClose || $[44] !== terminou) {
    t15 = isFirst ? <Button variant="neutral-secondary" onClick={onClose}>{terminou ? "Fechar" : "Ver depois"}</Button> : <Button variant="neutral-secondary" icon={<FeatherArrowLeft />} onClick={() => setSlide(_temp2)}>Voltar</Button>;
    $[42] = isFirst;
    $[43] = onClose;
    $[44] = terminou;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FeatherArrowRight />;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  const t17 = isLast ? "Ver planos" : "Continuar";
  let t18;
  if ($[47] !== handleAvancar || $[48] !== t17) {
    t18 = <Button variant="brand-primary" iconRight={t16} onClick={handleAvancar}>{t17}</Button>;
    $[47] = handleAvancar;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== t15 || $[51] !== t18) {
    t19 = <div className="flex items-center gap-3">{t15}{t18}</div>;
    $[50] = t15;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== t14 || $[54] !== t19 || $[55] !== t7) {
    t20 = <div className={t7}>{t14}{t19}</div>;
    $[53] = t14;
    $[54] = t19;
    $[55] = t7;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== t20 || $[58] !== t8 || $[59] !== t9) {
    t21 = <div className={t8}>{t9}{t20}</div>;
    $[57] = t20;
    $[58] = t8;
    $[59] = t9;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  let t23;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="pm-dots" />;
    t23 = <div className="pm-blur-orb" />;
    $[61] = t22;
    $[62] = t23;
  } else {
    t22 = $[61];
    t23 = $[62];
  }
  let t24;
  if ($[63] !== dataFim || $[64] !== diasRestantes || $[65] !== momento || $[66] !== possessivoLabel || $[67] !== produtoNome || $[68] !== unidadeLabel || $[69] !== usadoNoTeste) {
    t24 = <div className="from-brand-600 to-brand-800 relative flex min-h-[420px] items-center justify-center overflow-hidden bg-gradient-to-br md:flex-[3]">{t22}{t23}<PainelAnimado produtoNome={produtoNome} momento={momento} dataFim={dataFim} diasRestantes={diasRestantes} usadoNoTeste={usadoNoTeste} unidadeLabel={unidadeLabel} possessivoLabel={possessivoLabel} /></div>;
    $[63] = dataFim;
    $[64] = diasRestantes;
    $[65] = momento;
    $[66] = possessivoLabel;
    $[67] = produtoNome;
    $[68] = unidadeLabel;
    $[69] = usadoNoTeste;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== t10 || $[72] !== t21 || $[73] !== t24) {
    t25 = <div className={t10}>{t21}{t24}</div>;
    $[71] = t10;
    $[72] = t21;
    $[73] = t24;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] !== T0 || $[76] !== t11 || $[77] !== t25) {
    t26 = <T0 className={t11}>{t25}</T0>;
    $[75] = T0;
    $[76] = t11;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== T1 || $[80] !== t12 || $[81] !== t13 || $[82] !== t26) {
    t27 = <T1 open={t12} onOpenChange={t13}>{t26}</T1>;
    $[79] = T1;
    $[80] = t12;
    $[81] = t13;
    $[82] = t26;
    $[83] = t27;
  } else {
    t27 = $[83];
  }
  return t27;
};
function _temp(prev) {
  return prev + 1;
}
function _temp2(prev_0) {
  return Math.max(0, prev_0 - 1);
}